import $ from "jquery";
import '../plugins/anchors';


// initialize smooth anchor links
export default function initAnchors() {
	new SmoothScroll({
		anchorLinks: '.add-nav a[href], #navDropdown .dropdown-holder a[href]',
		extraOffset: $('header').innerHeight(),
		activeClasses: 'link',
		animDuration: 0
	});

	$('a[href^="#"].btn, .navbar-nav a.box').each(function () {
		const link = $(this);
		const href = link.attr('href');
		if (href !== '#') {
			const array = href.split('#');
			const id = array[array.length - 1];

			if(array.length < 2) return;

			const target = $(`#${id}`);

			if (target.length) {
				link.on('click', function (e) {
					e.preventDefault();
					window.scrollTo({
						top: target[0].offsetTop,
						behavior: "smooth",
					})
				})
			}
		}
	})
}
